module.exports = __webpack_public_path__ + "static/media/Memories.7f161e46.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Memories.woff2
// module id = 2241
// module chunks = 47